if (!customElements.get('crosssell-list-product')) {
  class CrosssellListProduct extends HTMLElement {
    constructor() {
      super();
      // this.qtyField = this.querySelector('[data-qty-input]');
      // this.qtyText = this.querySelector('[data-qty-text]');
      // this.parentProduct = this.getAttribute('data-parent-product');
      
      // const parentProductSelects = document.querySelector(`variant-radios[data-product-id="${this.parentProduct}"]`);

      // if (parentProductSelects) {
      //   parentProductSelects.addEventListener('optionChange', this.handleParentOptionChange.bind(this));
      // }
    }

    handleParentOptionChange(event) {
      const { option, value } = event.detail;

      if (option === 'Size') {
        this.qtyText.textContent = `${value}x`;
        this.qtyField.value = value;
      }
    }
  }

  customElements.define('crosssell-list-product', CrosssellListProduct);
}